// src/pages/institutions/InstitutionTopBar.jsx

import TopBar from "@/sot/primitives/TopBar.jsx";

export const INSTITUTION_TOP_BAR_NAVIGATION = Object.freeze({
  BACK: "back",
  NONE: "none",
});

/** Institution adapter: all title, subtitle and back-button markup lives in TopBar. */
export default function InstitutionTopBar({
  title,
  subtitle = "",
  navigation = INSTITUTION_TOP_BAR_NAVIGATION.NONE,
  onBack,
  backLabel = "Back",
  actions = null,
}) {
  const showsBack =
    navigation === INSTITUTION_TOP_BAR_NAVIGATION.BACK &&
    typeof onBack === "function";

  return <TopBar
    title={title}
    subtitle={subtitle}
    onBack={showsBack ? onBack : undefined}
    trailing={actions}
    showNavigationRow={showsBack || Boolean(actions)}
    backLabel={backLabel}
    titleWrapperClassName="mt-0 mb-0"
  />;
}
